import { render, staticRenderFns } from "./OperationPriceBasis.vue?vue&type=template&id=070ca6ff&scoped=true"
import script from "./OperationPriceBasis.vue?vue&type=script&lang=js"
export * from "./OperationPriceBasis.vue?vue&type=script&lang=js"
import style0 from "./OperationPriceBasis.vue?vue&type=style&index=0&id=070ca6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ca6ff",
  null
  
)

export default component.exports